import { useState, useEffect } from 'react';
import { Container, Table, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getMyMilestoneRewards } from '../../api/walletApi';

const cyan = '#00e5ff';
const th = { color: cyan, fontWeight: 600, fontSize: 13, padding: '12px 20px', border: 'none' };

const RewardsStatus = () => {
  const navigate = useNavigate();
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getMyMilestoneRewards()
      .then((res) => setMilestones(res.data.milestones || []))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load rewards status.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <button
          onClick={() => navigate('/account-status')}
          style={{ background: 'none', border: 'none', color: cyan, fontSize: 13, cursor: 'pointer', marginBottom: 20, padding: 0 }}
        >
          ‹ Back to Account Status
        </button>

        <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 4 }}>Rewards Status</h5>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>
          Milestone rank rewards and your progress toward each.
        </div>

        {error && (
          <div style={{ color: '#ff6666', background: 'rgba(200,50,50,0.12)', border: '1px solid rgba(200,50,50,0.3)', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" style={{ color: cyan }} />
          </div>
        ) : (
          <>
          <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,229,255,0.12)' }}>
            <Table responsive className="mb-0" style={{ background: 'transparent' }}>
              <thead>
                <tr style={{ background: 'rgba(0,229,255,0.07)', borderBottom: '1px solid rgba(0,229,255,0.15)' }}>
                  <th style={th}>Target Rank</th>
                  <th style={th}>Reward Amount</th>
                  <th style={th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {milestones.map((m) => (
                  <tr key={m.rank} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                    <td style={{ color: '#ffaa44', fontWeight: 700, fontSize: 13, padding: '14px 20px', border: 'none' }}>
                      {m.rank}
                    </td>
                    <td style={{ color: '#66ff99', fontWeight: 600, fontSize: 13, padding: '14px 20px', border: 'none' }}>
                      {m.rewardAmount} USDT
                    </td>
                    <td style={{ padding: '14px 20px', border: 'none' }}>
                      {m.achieved ? (
                        <span style={{ color: '#66ff99', fontSize: 12, fontWeight: 600 }}>
                          ✓ {m.amountCredited} USDT {m.isFullReward ? '(Full)' : '(50%)'}
                        </span>
                      ) : (
                        <span style={{ color: '#555', fontSize: 12 }}>Not yet achieved</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div style={{ color: '#666', fontSize: 12, marginTop: 12, paddingLeft: 4 }}>
            * Full reward if achieved within 90 days of the Slot-01 activation, else if achieved after 90 days, then receive 50% of the reward amount.
          </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default RewardsStatus;
